import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import { AlreadyLoginPage } from 'pages';
import { Intro } from 'components';

class CtIntro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alreadLogin: 0
    };
  }

  componentWillMount() {
    // 이미 로그인된 상태인지 확인하여 render 시 안내
    if (this.props.isAuth === 1) {
      this.setState({ alreadLogin: 1 });
    }
  }

  render() {
    const { isAuth, location, history } = this.props;

    // if (isAuth === 1) {
    //   // 이미 로그인 된 상태로 접속
    //   if (this.state.alreadLogin) {
    //     // 만약 로그인 된 상태에서 root로 넘어왔을경우 main으로 이동
    //     if (location.pathname !== '/intro') {
    //       const toPath = location.pathname === '/' ? '/main' : location.pathname;
    //       return <Redirect to={toPath} />;
    //     }

    //     return <AlreadyLoginPage accessLevel={1} />;
    //   }
    // }

    // // 로그인 안된 상태에서 root로 들어온 경우 url을 변경해준다.
    // if (location.pathname !== '/intro') {
    //   history.replace('/intro');
    // }


    return <Intro />;
  }
}

const mapStateToProps = state => ({
  isAuth: state.user.get('isAuth')
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CtIntro);



// WEBPACK FOOTER //
// ./src/script/containers/intro/CtIntro.js